
<main>
    <Banner/>
    <UserName/>
    <MainScreen />
    <Copyright />
    <PlayerMaintenance />
    <PartnerMaintenance />
    <MyNameMaintenance />
    <MessageMaintenance />
    <ConventionMaintenance />
    <NewItem />
</main>

<style>
</style>

<script>
    import Banner from "./Banner.svelte";
    import UserName from "./UserName.svelte";
    import MainScreen from "./MainScreen.svelte";
    import Copyright from "./Copyright.svelte";
    import PlayerMaintenance from "./PlayerMaintenance.svelte";
    import PartnerMaintenance from "./PartnerMaintenance.svelte"
    import MyNameMaintenance from "./MyNameMaintenance.svelte";
    import MessageMaintenance from "./MessageMaintenance.svelte";
    import ConventionMaintenance from "./ConventionMaintenance.svelte";
    import NewItem from "./NewItem.svelte";
</script>
